import { useContext } from 'react';
import EventLoggerContext from 'contexts/EventLoggerContext';
import { EventData } from 'lib/EventLogger/Event';
import { useSelector } from 'react-redux';
import State from 'types/State';
import UserData from 'lib/EventLogger/User';

type LogFunction = { log: (eventData: EventData) => Promise<void> };

export default function useEvents(): LogFunction {
  const user = useSelector<State, UserData>((state) => state.user);
  const logger = useContext(EventLoggerContext);

  logger.user = user;

  return logger;
}
